import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { DASHBOARD, HELP_LINK_PREFIX } from 'shared/constants/help-articles';

import IconButton from 'shared/components/button/icon/icon';
import { LinkButton } from 'shared/components/button/button';
import { openIFrameModal, closeCatcher } from 'shared/components/modal/modal';

import styles from './header.styl';


@withRouter
export default class ModalHeader extends React.Component {

  static propTypes = {
    router: PropTypes.object,
    title: PropTypes.any,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    titleClassName: PropTypes.string,
    onButtonClick: PropTypes.func,
    showHelpLink: PropTypes.bool,
  };

  static defaultProps = {
    onButtonClick: _.noop,
    showHelpLink: true,
  };

  @autobind
  openHelpModal() {
    const { isActive } = this.props.router;
    let helpLink;

    if (isActive('/video-library')) {
      helpLink = DASHBOARD.LIBRARY;
    } else if (isActive('/channels')) {
      helpLink = DASHBOARD.CHANNELS;
    } else if (isActive('/stats')) {
      helpLink = DASHBOARD.STATS;
    } else if (isActive('/settings')) {
      helpLink = DASHBOARD.SETTINGS;
    } else if (isActive('/email-marketing')) {
      helpLink = DASHBOARD.EMAIL_MARKETING;
    }

    openIFrameModal(`${HELP_LINK_PREFIX}${helpLink}`)
      .catch(closeCatcher);
  }

  get helpLink() {
    const { showHelpLink } = this.props;

    if (!showHelpLink) {
      return null;
    }

    return (
      <LinkButton onClick={this.openHelpModal}
                  className={classnames(styles.button, styles['help-button'])}>?</LinkButton>
    );
  }

  get title() {
    const { title, titleClassName } = this.props;

    if (!title) {
      return null;
    }

    return (
      <h1 data-hook="modal-title"
          className={classnames(styles.title, titleClassName)}>
        {title}
      </h1>
    );
  }

  render() {
    const { onButtonClick, className, buttonClassName } = this.props;
    const classNames = classnames(className, styles.header);

    return (
      <header data-hook="modal-header"
              className={classNames}>
        {this.title}
        {this.helpLink}
        <IconButton dataHook="header-close-button"
                    className={classnames(styles.button, styles['close-button'], buttonClassName)}
                    onClick={onButtonClick}
                    name="close" />
      </header>
    );
  }
}

function generateHeaderVariant(variantClassName) {

  class HeaderVariant extends React.Component {

    static propTypes = {
      className: PropTypes.string,
    };

    render() {
      const props = {
        ...this.props,
        className: classnames(this.props.className, variantClassName),
      };

      return <ModalHeader {...props} />;
    }
  }

  return HeaderVariant;
}

export const DangerModalHeader = generateHeaderVariant(styles.danger);
export const EmptyModalHeader = generateHeaderVariant(styles.empty);
export const SimpleModalHeader = generateHeaderVariant(styles.simple);
export const IFrameModalHeader = generateHeaderVariant(styles.iframe);
export const ModalHeaderWithHelp = generateHeaderVariant(styles.help);



// WEBPACK FOOTER //
// ./src/shared/components/modal/header/header.js